module.exports = __webpack_public_path__ + "img/uupay.757127da.svg";